// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "routes" + "-legacy." + "e30346c3" + ".js";
};